import { Model } from "@/models";

export default class IndicatorTaxonomy extends Model {
  static type = "indicatorTaxonomies";
  options: string[];
}
